import { Loading } from "components/shared";
import React, { useEffect } from "react";
import useMagicAction, { RESULT_SCHEMA, asText } from "./useMagicAction";


const AddEngagingQuestion = (props) => {

    const { run, input, writeBackInsert, closeMenu } = useMagicAction(props);

    useEffect(() => {
        run({
            prompt: input
                ? `Write one engaging question for the following text. Return only the question.\n\nTEXT:\n${input}`
                : `Write one engaging question relevant to the company. Return only the question.`,
            schema: RESULT_SCHEMA,
        })
            .then((r) => writeBackInsert(asText(r)))
            .finally(closeMenu);
    }, []);

    return (
        <div className="flex flex-col items-center justify-center gap-2">
            <Loading type={'element'} />
        </div>
    )
}

export default AddEngagingQuestion;
